// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ni-1";
export var messageSideRight = "_ni-2";
export var subscribeToBackInStockBubbleContainer = "_ni-0";